// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"f443d160","247":"7f9d64db","513":"030ceaf8","665":"eecd6c71","706":"cc727622"}[chunkId] + ".chunk.js";
};